import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { AppDataContext } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import { ConfirmDialog } from '../ConfirmDialog';
import { validateEmail } from '../../helpers';
import { Helmet } from "react-helmet";

export function PersonalInfo(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

    // this will toggle the class which shows field validation
    const [formWasValidated, setFormWasValidated] = useState(false);

    // error message at the top
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);


    const [email, setEmail] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [editMode, setEditMode] = useState(false);

    const updateNewEmailValue = (evt) => { setNewEmail(evt.target.value) };
    const updateFirstNameValue = (evt) => { setFirstName(evt.target.value); };
    const updateLastNameValue = (evt) => { setLastName(evt.target.value); };
    const updatePhoneNumberValue = (evt) => { setPhoneNumber(evt.value) };
    const updateCompanyNameValue = (evt) => { setCompanyName(evt.target.value) };
    const updateAddress1Value = (evt) => { setAddress1(evt.target.value) };
    const updateAddress2Value = (evt) => { setAddress2(evt.target.value) };
    const updateCityValue = (evt) => { setCity(evt.target.value) };
    const updateStateValue = (evt) => { setState(evt.target.value) };
    const updateZipValue = (evt) => { setZip(evt.value) };


    const loadPerson = async () => {
        const url = 'api/site/userprofile/';

        const response = await netRequest(url);

        if (response.data != null) {
            setEmail(response.data.email);
            setNewEmail(response.data.email);
            setFirstName(response.data.firstName);
            setLastName(response.data.lastName);
            setPhoneNumber(response.data.phone ?? "");
            setCompanyName(response.data.companyName ?? "");
            setAddress1(response.data.address1 ?? "");
            setAddress2(response.data.address2 ?? "");
            setCity(response.data.city ?? "");
            setState(response.data.state ?? "");
            setZip(response.data.zip ?? "");
        }
    };
       
    useEffect(() => {

        if (context.isLoggedIn)
            loadPerson();

    }, [context.isLoggedIn]);

    const enableEdit = async () => {
        setEditMode(true);
        setMessage(null);
    }
    const cancelEdit = async () => {
        setEditMode(false);
        await loadPerson();
    }
    const save = async () => {
        setFormWasValidated(true);
        setMessage(null);
        const url = 'api/site/saveuserprofile';

        if (firstName.trim() != '' && lastName.trim() != '' &&
            phoneNumber.trim() != '' && address1.trim() != '' && city.trim() != '' &&
            state.trim() != '' && zip.trim() != '') {
            const postData = {
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                phone: phoneNumber.trim(),
                companyName: companyName.trim(),
                address1: address1.trim(),
                address2: address2?.trim(),
                city: city.trim(),
                state: state.trim(),
                zip: zip.trim()
            };

            const resp = await netRequest(url, postData);

            if (resp.isError) {
                setIsError(true);
                setMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else {
                setIsError(false);
                setFormWasValidated(false);
                setMessage("Profile Saved");
                setEditMode(false);

            }
        } else {
            setMessage("Please fill in all required fields");
        }
    }

    const [pwWasValidated, setPwWasValidated] = useState("");
    const [currentPassword, setCurrentPassword] = useState(null);
    const [newPassword, setNewPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);
    const updateCurrentPasswordValue = (evt) => { setCurrentPassword(evt.target.value) };
    const updateNewPasswordValue = (evt) => { setNewPassword(evt.target.value) };
    const updateConfirmPasswordValue = (evt) => { setConfirmPassword(evt.target.value) };
    const clearChangePasswordFields = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setPwWasValidated("");
        setMessage(null);
    }

    const changePasswordOkClicked = async () => {
        setPwWasValidated("was-validated");
        if (currentPassword.trim() == "")
            setCurrentPassword("");

        if (newPassword.trim() == "")
            setNewPassword("");

        if (confirmPassword.trim() == "")
            setConfirmPassword("");

        if (currentPassword.trim() == "" || newPassword.trim() == "" || confirmPassword.trim() == "")
            return false;

        if (newPassword != confirmPassword)
            return "The new password and the confirm password must match";

        const url = 'api/site/changepassword';
        const postData = {
            CurrentPassword: currentPassword,
            NewPassword: newPassword,
        };

        const resp = await netRequest(url, postData);

        if (resp.isError) {
            return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
        } else if (resp.data != null) {
            return resp.data;
        }

        setMessage("Your Password has been changed");
        return null;

    }

    const [okButtonText, setOkButtonText] = useState(null);
    const [validationCode, setValidationCode] = useState('');
    const [validating, setValidating] = useState(false);
    const updateValidationCodeValue = (evt) => { setValidationCode(evt.target.value) };

    const clearChangeEmailFields = () => {
        setValidating(false);
        setValidationCode(null);
        setOkButtonText("Send Code");
    }

    const changeEmailOkClicked = async () => {
        // the dialog is basically a 2 step wizard.
        if (validating == false) {
            if (!validateEmail(newEmail)) {
                return 'Invalid email address.';
            } else if (newEmail.toLocaleLowerCase().trim() == email.toLocaleLowerCase().trim()) {
                return 'The new address is the same as the current!';
            } else {
                // initiate validation process (send emails)

                const url = 'api/site/RequestEmailChange';
                const postData = {
                    Param: newEmail,
                };

                const resp = await netRequest(url, postData);

                if (resp.isError) {
                    return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
                } else if (resp.data != null) {
                    return resp.data;
                }

                setOkButtonText("Verify");
                setValidating(true);
                return false;
            }
        } else {
            // confirm validation code
            const url = 'api/site/verifyemail/' + validationCode;

            const resp = await netRequest(url);

            if (resp.status != 200 || resp.data == null) {
                return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
            } else if (resp.data.result == false) {
                return "That verification code does not exist.  Please check your email again.  If you copied the code into your browser, make sure the whole code is there.";
            } else {
                loadPerson();
                setMessage("Email address changed.  Remember to use this address when logging in going forward");
                setEditMode(false);
                return null;
            }
        }
       
    }

    return (
        <>
            <Helmet>
                <title>Personal Information</title>
            </Helmet>

            <ConfirmDialog cancelText="Cancel" okText={okButtonText}
                okClicked={changeEmailOkClicked}
                id="changeEmailModal"
                headerText="Change Email Address"
                modalSize='modal-md'
                staticBackdrop={true}
            >
                {validating == false ?
                    <div>
                        <p>Type in your new email address, below</p>
                        <p>
                            A notification of the address change will be sent to your current email address, and a verification
                            email will be sent to the new address.
                        </p>
                        <p><strong>Note that once the address is changed, you will need to log in with that email address going forward.</strong></p>
                        <div class="input-group has-validation was-validated">
                            <label for="email" class="form-label w-100">Email<span>*</span></label>
                            <input type="text" class="form-control" id="email" placeholder="Email" required
                                pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                onChange={evt => updateNewEmailValue(evt)}
                                value={newEmail}
                            />
                            <div class="invalid-feedback">
                                Please enter your email.
                            </div>
                        </div>                        
                    </div>
                    :
                    <div>
                        <p>You are changing your email address to: <strong>{newEmail}</strong></p>
                        <p>A verification code has been sent to your new email address.  Please check your email (and spam folder) and enter the code you received, below</p>
                        <div class="input-group has-validation">
                            <label for="validationCode" class="form-label w-100">Validation Code<span>*</span></label>
                            <input type="validationCode" class="form-control" id="validationCode" placeholder="Validation Code" required
                                onChange={evt => updateValidationCodeValue(evt)}
                                value={validationCode}
                            />
                            <div class="invalid-feedback">
                                Please enter the validation code.
                            </div>
                        </div>
                    </div>
                }
            </ConfirmDialog>

            <ConfirmDialog cancelText="Cancel" okText="Change"
                okClicked={changePasswordOkClicked}
                id="changePasswordModal"
                headerText="Change Password"
                modalSize='modal-md'
            >
                <div>
                    <p>
                        To change your password, you must type in your current password, the new password, and confirm the new password.
                    </p>
                    <div className={"input-group has-validation mb-1 " + pwWasValidated}>
                        <label for="email" class="form-label w-100">Current Password<span>*</span></label>
                        <input type="password" class="form-control" id="currentPassword" placeholder="" required
                            onChange={evt => updateCurrentPasswordValue(evt)}
                            value={currentPassword}
                        />
                        <div class="invalid-feedback">
                            Please enter your current password.
                        </div>
                    </div>
                    <div className={"input-group has-validation mb-1 " + pwWasValidated}>
                        <label for="email" class="form-label w-100">New Password<span>*</span></label>
                        <input type="password" class="form-control" id="password" placeholder="" required
                            onChange={evt => updateNewPasswordValue(evt)}
                            value={newPassword}
                        />
                        <div class="invalid-feedback">
                            Please enter the new password.
                        </div>
                    </div>
                    <div className={"input-group has-validation " + pwWasValidated}>
                        <label for="email" class="form-label w-100">Confirm Password<span>*</span></label>
                        <input type="password" class="form-control" id="password" placeholder="" required
                            onChange={evt => updateConfirmPasswordValue(evt)}
                            value={confirmPassword}
                        />
                        <div class="invalid-feedback">
                            Please reenter the new password.
                        </div>
                    </div>
                </div>
            </ConfirmDialog>
            <div class="row mt-3">
                <div class="col-12 mb-1">
                    <h4 class="auction-grid-header">
                        Personal Information
                        <div class="divider mt-2"></div>
                    </h4>
                    {
                        message ? <div className={"alert " + (isError ? "alert-danger" : "alert-success")} >{message}</div> : ""
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-6 mb-6">
                    {editMode == false ?
                        <>
                            <button type="button" onClick={enableEdit} class="btn badge btn-secondary btn-fill">Edit My Information</button><br /><br />
                        </>
                        :
                        <>
                            <button type="button" onClick={cancelEdit} class="btn badge btn-secondary">Cancel</button><br /><br />
                        </>
                    }
                </div>
                {editMode == false &&
                    <div class="col-md-3 col-lg-3 mb-3">
                        <button type="button" onClick={clearChangePasswordFields} class="btn badge btn-secondary btn-fill" data-bs-toggle="modal" data-bs-target="#changePasswordModal">Change my Password</button><br /><br />
                    </div>
                }
            </div>
            <div class="row align-items-end">
                <div class="col-md-6 col-lg-6 mb-6">
                    <div class="input-group">
                        <label class="form-label w-100">Email</label>
                        <input type="text" class="form-control" value={email} disabled={true} />
                    </div>
                </div>
                {editMode == false &&
                    <div class="col-md-6 col-lg-6 mb-6">
                        <button type="button" class="btn badge btn-secondary btn-fill" onClick={clearChangeEmailFields}
                            data-bs-toggle="modal"
                            data-bs-target="#changeEmailModal"
                        >Change my Email Address</button>
                    </div>
                }
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-6 mb-3">
                    <div class="input-group has-validation">
                        <label for="text" class="form-label w-100">First Name<span>*</span></label>
                        <input type="text" class="form-control" id="firstname" placeholder="First Name" required
                            onChange={evt => updateFirstNameValue(evt)}
                            value={firstName} disabled={editMode == false ? "disabled" : ""} />
                        <div class="invalid-feedback">
                            Please enter your First Name.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <div class="input-group has-validation">
                        <label for="text" class="form-label w-100">Last Name<span>*</span></label>
                        <input type="text" class="form-control" id="lastname" placeholder="Last Name" required
                            onChange={evt => updateLastNameValue(evt)}
                            value={lastName} disabled={editMode == false ? "disabled" : ""}
                        />
                        <div class="invalid-feedback">
                            Please enter your Last Name.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <div class="input-group has-validation">
                        <label for="phone" class="form-label w-100">Phone Number<span>*</span></label>
                        <CurrencyFormat class="form-control" id="phone" placeholder="Phone Number" required value={phoneNumber}
                            onValueChange={evt => updatePhoneNumberValue(evt)} format="(###) ###-####" mask="_"
                            disabled={editMode == false ? "disabled" : ""}
                        />

                        <div class="invalid-feedback">
                            Please enter your phone number.
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="input-group has-validation">
                        <label for="companyName" class="form-label w-100">Company Name (optional)</label>
                        <input type="text" class="form-control" id="companyName" placeholder="Company Name"
                            onChange={evt => updateCompanyNameValue(evt)}
                            value={companyName} disabled={editMode == false ? "disabled" : ""}
                        />
                        <div class="invalid-feedback">
                            Please enter your address.
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="input-group has-validation">
                        <label for="address1" class="form-label w-100">Address 1<span>*</span></label>
                        <input type="text" class="form-control" id="address1" placeholder="Address" required
                            onChange={evt => updateAddress1Value(evt)}
                            value={address1} disabled={editMode == false ? "disabled" : ""}
                        />
                        <div class="invalid-feedback">
                            Please enter your address.
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="input-group has-validation">
                        <label for="address2" class="form-label w-100">Address 2</label>
                        <input type="text" class="form-control" id="address2" placeholder=""
                            onChange={evt => updateAddress2Value(evt)}
                            value={address2} disabled={editMode == false ? "disabled" : ""}
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 mb-3">
                    <div class="input-group has-validation">
                        <label for="city" class="form-label w-100">City<span>*</span></label>
                        <input type="text" class="form-control" id="city" placeholder="City" onChange={evt => updateCityValue(evt)}
                            value={city} disabled={editMode == false ? "disabled" : ""}
                        />
                    </div>
                    <div class="invalid-feedback">
                        Please enter your city.
                    </div>
                </div>
                <div class="col-12 col-md-3 mb-3">
                    <div class="input-group has-validation">
                        <label for="state" class="form-label w-100">State<span>*</span></label>
                        <select class="form-control" id="state" placeholder="State" required
                            onChange={evt => updateStateValue(evt)}
                            value={state}
                            disabled={editMode == false ? "disabled" : ""}
                        >
                            <option value=""> </option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>
                    </div>
                    <div class="invalid-feedback">
                        Please enter your state.
                    </div>
                </div>
                <div class="col-12 col-md-3 mb-3">
                    <div class="input-group has-validation">
                        <label for="zip" class="form-label w-100">Zip Code<span>*</span></label>
                        <CurrencyFormat class="form-control" id="zip" placeholder="Zip Code" required value={zip}
                            onValueChange={evt => updateZipValue(evt)} format="#####"
                            disabled={editMode == false ? "disabled" : ""}
                        />

                        <div class="invalid-feedback">
                            Please enter your zip.
                        </div>
                    </div>
                </div>
                
                <div class="offset-lg-4 col-md-12 col-lg-4 align-self-center mb-3">
                    {editMode ? <button type="button" onClick={save} class="btn btn-secondary btn-fill w-100">Update</button>
                   :'' }
                </div>
                

            </div>

            <Loader loading={loading} />


        </>
    );

}
